import { NgOptimizedImage } from '@angular/common';
import { Component, inject, output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { LucideModule } from '../../modules/lucide.module';

@Component({
  selector: 'app-input-buscar',
  templateUrl: './input-buscar.component.html',
  styleUrls: ['./input-buscar.component.css'],
  imports: [LucideModule, NgOptimizedImage],
})
export class InputBuscarComponent {
  private readonly router = inject(Router);

  readonly placeholder = 'Serviço Digital, Agendamento, Serviço Presencial, Ouvidoria...';

  readonly termo = signal('');

  readonly buscar = output<string>();

  aoDigitar(event: Event): void {
    this.termo.set((event.target as HTMLInputElement).value);
  }

  /** Enter e o botão "Buscar" caem aqui: um caminho só, que leva a `/resultado-busca?q=`. */
  aoSubmeter(event: Event): void {
    event.preventDefault();
    const valor = this.termo().trim();
    if (!valor) return;

    this.buscar.emit(valor);
    this.irParaResultado(valor);
  }

  private irParaResultado(termo: string): void {
    this.router.navigate(['/resultado-busca'], { queryParams: { q: termo } });
  }
}
